import React, { Component } from "react";

import { connect } from "react-redux";
import {
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	CardText,
	Button,
} from "reactstrap";

import moment from "moment";
import {
	GetPIItemTimeLine,
	GetPOItemTimeLine,
	GetIGPItemTimeLine,
} from "../../store/MaterialRequest/actions";

import "./TimeLineLogRightbar.scss";
class TimeLineCard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		var item = this.props.item;

		switch (item.type) {
			case "MRCreate":
				return (
					<li>
						<span></span>
						<Card
							outline
							color={
								item.mrstatus === 1 || item.mrstatus === 2
									? "primary"
									: item.mrstatus === 3 || item.mrstatus === 5
									? "success"
									: item.mrstatus === 4 || item.mrstatus === 6
									? "danger"
									: item.mrstatus === 9 ||
									  item.mrstatus === 10
									? "warning"
									: item.mrstatus === 7 || item.mrstatus === 8
									? "info"
									: "primary"
							}
							className="border">
							<CardHeader
								className={
									item.mrstatus === 1 || item.mrstatus === 2
										? "bg-primary"
										: item.mrstatus === 3 ||
										  item.mrstatus === 5
										? "bg-success"
										: item.mrstatus === 4 ||
										  item.mrstatus === 6
										? "bg-danger"
										: item.mrstatus === 9 ||
										  item.mrstatus === 10
										? "bg-warning"
										: item.mrstatus === 7 ||
										  item.mrstatus === 8
										? "bg-info"
										: "bg-primary"
								}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									SR Item Created
									<span className="float-right">
										{/* {item.approvedby.fullname}({item.approvedby.username}) */}
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle className="mt-0 font-size-16">
									{item.product.name}
								</CardTitle>

								<CardText className="info">
									<span className="text-dark">
										Quantity:{" "}
									</span>
									{item.qty} {item.unit.name}
									<br />
								</CardText>
							</CardBody>
						</Card>

						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);

			case "MRlevel":
				return (
					<li>
						<span></span>
						<Card
							outline
							color={
								item.mrstatus === 1 || item.mrstatus === 2
									? "primary"
									: item.mrstatus === 3 || item.mrstatus === 5
									? "success"
									: item.mrstatus === 4 || item.mrstatus === 6
									? "danger"
									: item.mrstatus === 9 ||
									  item.mrstatus === 10
									? "warning"
									: item.mrstatus === 7 || item.mrstatus === 8
									? "info"
									: "primary"
							}
							className="border">
							<CardHeader
								className={
									item.mrstatus === 1 || item.mrstatus === 2
										? "bg-primary"
										: item.mrstatus === 3 ||
										  item.mrstatus === 5
										? "bg-success"
										: item.mrstatus === 4 ||
										  item.mrstatus === 6
										? "bg-danger"
										: item.mrstatus === 9 ||
										  item.mrstatus === 10
										? "bg-warning"
										: item.mrstatus === 7 ||
										  item.mrstatus === 8
										? "bg-info"
										: "bg-primary"
								}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									SR {item.mrstatus_name}
									<span className="float-right">
										{item.approvedby.fullname}(
										{item.approvedby.username})
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle className="mt-0 font-size-16">
									{item.t_product.name}
								</CardTitle>

								<CardText className="info">
									<span className="text-dark">
										Quantity:{" "}
									</span>
									{item.t_qty} {item.t_unit.name}
									<br />
									{item.description !== null && (
										<>
											<span className="text-danger">
												Reject Remark:{" "}
											</span>
											{item.description}

											<br />
										</>
									)}
								</CardText>
							</CardBody>
						</Card>

						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);
			case "MRIssueCreate":
				return (
					<li>
						<span></span>
						<Card outline color="primary" className="border">
							<CardHeader className="bg-primary">
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									SR Item Issue
									<span className="float-right">
										{item.createdby.fullname}(
										{item.createdby.username})
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle className="mt-0 font-size-16">
									{item.product.name}
								</CardTitle>

								<CardText className="info">
									<span className="text-dark">
										Quantity:{" "}
									</span>
									{item.qty} {item.unit.name}
									<br />
									<span className="text-dark">
										location:{" "}
									</span>
									{item.location.name}
									<br />
									<span className="text-dark">
										Issue Code:{" "}
									</span>
									{item.mrissueCode}
									<br />
								</CardText>
							</CardBody>
						</Card>

						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);

			case "PICreate":
				return (
					<li>
						<span></span>

						<Card outline color={"primary"} className="border">
							<CardHeader className={"bg-primary"}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									PI Created
									<span className="float-right">
										{/* {item.approvedby.fullname}({item.approvedby.username}) */}
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								{this.props.PITimeLineItems.map((item) => (
									<Button
										color="primary"
										outline={
											item.id ===
											this.props.selectedPIItemId
												? false
												: true
										}
										onClick={() => {
											this.props.GetPIItemTimeLine(item);
										}}
										className="mr-2">
										{item.piitem.purchaseindent.code}
									</Button>
								))}
							</CardBody>
						</Card>
						{/* <div class="time text-primary">
              <span>
                {moment().format("DD-MM-YYYY")}
                <br />
                {moment().format("LTS")}
              </span>
            </div> */}
					</li>
				);

			case "PIICreate":
				return (
					<li>
						<span></span>
						<Card outline color={"primary"} className="border">
							<CardHeader className={"bg-primary"}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									PI Item Created
									<span className="float-right">
										{item.createdby.fullname}(
										{item.createdby.username})
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle className="mt-0 font-size-16">
									{item.product.name}
								</CardTitle>

								<CardText className="info">
									<span className="text-dark">
										Quantity:{" "}
									</span>
									{item.qty}
									{/* {item.unit.name} */}
									<br />
								</CardText>
							</CardBody>
						</Card>

						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);

			case "PIIApproval":
				return (
					<li>
						<span></span>
						<Card
							outline
							color={item.pistatus === 3 ? "success" : "danger"}
							className="border">
							<CardHeader
								className={
									item.pistatus === 3
										? "bg-success"
										: "bg-danger"
								}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									PI Item {item.pistatus_name}
									<span className="float-right">
										{item.approvedby.fullname}(
										{item.approvedby.username})
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle tag="h5" className="mt-0">
									{item.product.name}
								</CardTitle>
								<CardText>
									<span className="text-dark">
										Quantity:{" "}
									</span>
									{item.t_qty} {item.t_unit.name}
									<br />
									{item.description !== null && (
										<>
											<span className="text-danger">
												Reject Remark:{" "}
											</span>
											{item.description}

											<br />
										</>
									)}
								</CardText>
							</CardBody>
						</Card>
						{/* <div class="title">comment #01</div>
            <div class="info">
              the best animation , the best toturials you would
              ever see .
            </div>
            <div class="name">- dr. mohamed -</div> */}
						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);

			case "PIApproval":
				return (
					<li>
						<span></span>
						<Card
							outline
							color={item.pistatus === 3 ? "success" : "danger"}
							className="border">
							<CardHeader
								className={
									item.pistatus === 3
										? "bg-success"
										: "bg-danger"
								}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									PI {item.pistatus_name} (
									{item.purchaseindent_code})
									<span className="float-right">
										{item.approvedby.fullname}(
										{item.approvedby.username})
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle tag="h5" className="mt-0">
									{item.product.name}
								</CardTitle>
							</CardBody>
						</Card>
						{/* <div class="title">comment #01</div>
              <div class="info">
                the best animation , the best toturials you would
                ever see .
              </div>
              <div class="name">- dr. mohamed -</div> */}
						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);

			case "RFQICreate":
				return (
					<li>
						<span></span>
						<Card outline color={"primary"} className="border">
							<CardHeader className={"bg-primary"}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									RFQ Item Created ({item?.RFQ_code})
									<span className="float-right">
										{item.createdby.fullname}(
										{item.createdby.username})
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle className="mb-0 font-size-16 text-dark">
									{item.product.name}
								</CardTitle>

								<CardText className="info">
									<p className="mb-0">
										<b className="text-dark">Quantity:</b>{" "}
										<span className="font-weight-medium">
											{item.qty}
											{/* {item.unit.name} */}
										</span>
									</p>
								</CardText>
							</CardBody>
						</Card>

						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);

			case "CQCreate":
				return (
					<li>
						<span></span>

						<Card outline color={"primary"} className="border">
							<CardHeader className={"bg-primary"}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									Selected Vendors
									<span className="float-right">
										{/* {item.approvedby.fullname}({item.approvedby.username}) */}
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								{this.props.CQTimeLineItems.map((item) => (
									<Button
										color={
											item.poitem.length !== 0
												? "primary"
												: "secondary"
										}
										outline={
											item.id ===
											this.props.selectedCQItemId
												? false
												: true
										}
										onClick={() => {
											if (item.poitem.length !== 0) {
												this.props.GetPOItemTimeLine(
													item
												);
											}
										}}
										className="mr-2">
										{item.vendor.name}
									</Button>
								))}
							</CardBody>
						</Card>
						{/* <div class="time text-primary">
              <span>
                {moment().format("DD-MM-YYYY")}
                <br />
                {moment().format("LTS")}
              </span>
            </div> */}
					</li>
				);

			case "POICreate":
				return (
					<li>
						<span></span>
						<Card outline color={"primary"} className="border">
							<CardHeader className={"bg-primary"}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									PO Item Created ({item.purchaseorder_code})
									<span className="float-right">
										{item.createdby.fullname}(
										{item.createdby.username})
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle className="mb-0 pb-0 font-size-16 text-dark">
									{item.product.name}
								</CardTitle>

								<CardText className="info">
									<p className="mb-0">
										<b className="text-dark">Quantity:</b>{" "}
										<span className="font-weight-medium">
											{item.qty}
											{/* {item.unit.name} */}
										</span>
									</p>
									<p className="mb-0">
										<b className="text-dark">Item Price:</b>{" "}
										<span className="font-weight-medium">
											{item.price}
										</span>
									</p>
									<p className="mb-0">
										<b className="text-dark">
											Gross value:
										</b>{" "}
										<span className="font-weight-medium">
											{item.gross}
										</span>
									</p>
								</CardText>
							</CardBody>
						</Card>

						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);
			case "IGPCreate":
				return (
					<li>
						<span></span>

						<Card outline color={"primary"} className="border">
							<CardHeader className={"bg-primary"}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									IGP Items
									<span className="float-right"></span>
								</h5>
							</CardHeader>
							<CardBody>
								{this.props.IGPTimeLine.map((item) => (
									<Button
										color="primary"
										outline={
											item.id ===
											this.props.selectedIGPItemId
												? false
												: true
										}
										onClick={() => {
											this.props.GetIGPItemTimeLine(item);
										}}
										className="mr-2">
										{item.goodsreceivednote2_code}
									</Button>
								))}
							</CardBody>
						</Card>
						{/* <div class="time text-primary">
              <span>
                {moment().format("DD-MM-YYYY")}
                <br />
                {moment().format("LTS")}
              </span>
            </div> */}
					</li>
				);
			case "IGPICreate":
				return (
					<li>
						<span></span>
						<Card outline color={"primary"} className="border">
							<CardHeader className={"bg-primary"}>
								<h5 className="my-0 text-white">
									<i className="mdi mdi-bullseye-arrow mr-3"></i>
									IGP Code ({item.igpcode})
									<span className="float-right">
										{/* {item.createdby.fullname}({item.createdby.username}) */}
									</span>
								</h5>
							</CardHeader>
							<CardBody>
								<CardTitle className="mb-0 pb-0 font-size-16 text-dark">
									{/* {item.product.name} */}
								</CardTitle>

								<CardText className="info">
									{/* <p className="mb-0">
                    <b className="text-dark">IGP DATE:</b>{" "}
                    <span className="font-weight-medium">
                      {item.qty}
                      {item.unit.name}
                    </span>
                  </p> */}
									<p className="mb-0">
										<b className="text-dark">
											Person Name:
										</b>{" "}
										<span className="font-weight-medium">
											{item.personname}
										</span>
									</p>
									<p className="mb-0">
										<b className="text-dark">Vehicle No:</b>{" "}
										<span className="font-weight-medium">
											{item.vehicleno}
										</span>
									</p>
								</CardText>
							</CardBody>
						</Card>

						<div class="time text-primary">
							<span>
								{moment(item.createdon).format("DD-MM-YYYY")}
								<br />
								{moment(item.createdon).format("LTS")}
							</span>
						</div>
					</li>
				);

			default:
				return <></>;
		}
	}
}
const mapStatetoProps = (state) => {
	const {
		PITimeLineItems,
		selectedPIItemId,
		CQTimeLineItems,
		IGPTimeLine,
		selectedCQItemId,
		selectedIGPItemId,
	} = state.Materialrequest;

	return {
		PITimeLineItems,
		selectedPIItemId,
		CQTimeLineItems,
		IGPTimeLine,
		selectedCQItemId,
		selectedIGPItemId,
	};
};
export default connect(mapStatetoProps, {
	GetPIItemTimeLine,
	GetPOItemTimeLine,
	GetIGPItemTimeLine,
})(TimeLineCard);
